export default __webpack_public_path__ + "static/media/004-A-fournisseurelectricite.d0c36654.svg";